import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  TooltipItem,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'
import type { HourlyData } from '../../lib/types'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

interface HourlyPatternChartProps {
  data: HourlyData
}

export function HourlyPatternChart({ data }: HourlyPatternChartProps) {
  // Aggregate by hour across all days
  const hourlyTotals = new Array(24).fill(0)
  data.forEach((d) => {
    hourlyTotals[d.hour_utc] += d.events
  })

  const chartData = {
    labels: Array.from({ length: 24 }, (_, i) => {
      const hour = i % 12 || 12
      const ampm = i < 12 ? 'AM' : 'PM'
      return `${hour}${ampm}`
    }),
    datasets: [
      {
        label: 'Events',
        data: hourlyTotals,
        backgroundColor: hourlyTotals.map((_, i) => {
          // Highlight business hours
          if (i >= 8 && i <= 18) {
            return 'hsl(222.2, 47.4%, 11.2%)'
          }
          return 'hsl(215.4, 16.3%, 76.9%)'
        }),
        borderRadius: 4,
      },
    ],
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          title: (context: TooltipItem<'bar'>[]) => `${context[0].label} UTC`,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          color: 'hsl(214.3, 31.8%, 91.4%)',
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  }

  return (
    <div className="space-y-4">
      <div className="h-[300px]">
        <Bar data={chartData} options={options} />
      </div>
      <p className="text-xs text-muted-foreground text-center">
        Times shown in UTC. Darker bars indicate business hours (8AM-6PM UTC).
      </p>
    </div>
  )
}
